import React from "react";

import { Button, ButtonGroup, Col, Form } from "react-bootstrap";
import { useWatch } from "react-hook-form";

import { useTournamentContext } from "../../../contexts/Tournament";

const RegistrationStatus = (): React.JSX.Element => {
    const { methods, isCreatingTournament, tournament } =
        useTournamentContext();

    const isTournamentActive = useWatch({
        control: methods.control,
        name: "active",
        defaultValue: isCreatingTournament
            ? false
            : Boolean(tournament?.active),
    });
    return (
        <Form.Group controlId="active" as={Col} md={4}>
            <Form.Label>Registration (Open or Closed)</Form.Label>
            <Form.Control
                type="hidden"
                {...methods.register("active", {
                    value: isCreatingTournament
                        ? false
                        : methods.getValues("active") ||
                          Boolean(tournament?.active),
                })}
            />
            <br />
            <ButtonGroup>
                <Button
                    variant={isTournamentActive ? "primary" : "outline-primary"}
                    onClick={() => methods.setValue("active", true)}
                >
                    Open
                </Button>
                <Button
                    variant={isTournamentActive ? "outline-primary" : "primary"}
                    onClick={() => methods.setValue("active", false)}
                >
                    Closed
                </Button>
            </ButtonGroup>
        </Form.Group>
    );
};

export default RegistrationStatus;
